import { useEffect, useState } from "react";
import { Badge, Table } from "react-bootstrap";
import api from "@/api/api.js";
import DigitalSignatureDownload from "./DigitalSignatureDownload.jsx";

const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
};

const DigitalSignatureList = ({ company }) => {
  const [signatures, setSignatures] = useState([]);

  useEffect(() => {
    const fetchListSignatures = async () => {
      try {
        const response = await api.get(
          `/companies/${company.id}/digitalSignature/all`,
        );
        setSignatures(response.data);
      } catch (e) {
        console.error(e);
      }
    };
    fetchListSignatures();
  }, [company.id]);

  return (
    <Table striped bordered responsive>
      <thead>
        <tr>
          <th>Version</th>
          <th>Vigente desde</th>
          <th>Expira el</th>
          <th>Estado</th>
          <th>Subida</th>
          <th>Nombre del archivo</th>
        </tr>
      </thead>
      <tbody>
        {signatures.length === 0 ? (
          <tr>
            <td colSpan={6} className="text-center text-muted">
              Sin firmas digitales registradas.
            </td>
          </tr>
        ) : (
          signatures.map((sig) => (
            <tr key={sig.id}>
              <td>{sig.version}</td>
              <td>{fmtDate(sig.validFrom)}</td>
              <td className={sig.isExpired ? "text-danger fw-bold" : ""}>
                {fmtDate(sig.validTo)}
              </td>
              <td>
                {sig.isExpired ? (
                  <Badge bg="danger">Expirada</Badge>
                ) : (
                  <Badge bg="success">Vigente</Badge>
                )}
              </td>
              <td>{sig.createdAtHuman}</td>
              <td>
                <DigitalSignatureDownload
                  companyId={company.id}
                  signatureId={sig.id}
                  fileName={sig.originalName}
                />
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default DigitalSignatureList;
